<template>
    <div>
        <div align="center" id="detail" style="display: block;">
            <table :class="tableClass">
                <caption v-if="this.resultat.isBaremeRectif || this.resultat.isBaremeAjuste" v-html="
                         this.$t('Calculette.result.resultatRectif', {
                         bareme: this.resultat.isBaremeAjuste ? this.resultat.codeBaremePrelevement : this.resultat.bareme,
                         periodeFiscale: (Number(this.resultat.annee) + 1),
                         url: 'https://www.ge.ch/document/bareme-c-rectification-impot-source-' + this.resultat.annee})">
                </caption>
                <caption v-else> {{this.$t('Calculette.result.resultat')}}
                </caption>
                <thead class="hidden">
                    <tr>
                        <th scope="col">{{this.$t('general.resultat')}}</th>
                        <th scope="col">{{this.$t('general.valeur')}}</th>
                    </tr>
                </thead>
                <tbody>
                <tr v-if="(resultat.isBaremeRectif || resultat.isBaremeAjuste)">
                    <td :class='colLeft'>{{ $t("Calculette.result.revenuUtilisePourLeTaux") }}
                    </td>
                    <td :class='colRight'>{{formatCurrency(resultat.revenuUtilisePourLeTaux)}}</td>
                </tr>
                <tr>
                    <td :class='colLeft'>{{ $t("Calculette.result.revenuImpose") }}
                    </td>
                    <td :class='colRight'>
                        {{formatCurrency(resultat.revenuImpose)}}
                    </td>
                </tr>
                <tr>
                    <td :class='colLeft'>{{ $t("Calculette.result.taux") }}</td>
                    <td :class='colRight'>{{resultat.taux}}%</td>
                </tr>
                <tr >
                    <td :class='colLeft'><b>{{ $t("Calculette.result.montantImpot") }}</b></td>
                    <td :class='colRight'>
                        <b>
                            {{formatCurrency(resultat.montantImpot)}}
                        </b>
                    </td>
                </tr>
                </tbody>
            </table>
            <br>


        </div>
    </div>
</template>

<script>
import CurrencyUtils from '@/utils/CurrencyUtils';

export default {
  name: 'section-resultat-calculette',
  props: ['resultat', 'colLeft', 'colRight', 'tableClass'],
  mixins: [CurrencyUtils],
};
</script>

<style scoped>

</style>
